import { render, staticRenderFns } from "./PermissionsHead.vue?vue&type=template&id=f48e4ede"
import script from "./PermissionsHead.vue?vue&type=script&lang=js"
export * from "./PermissionsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports